export const WSS_SCHEME = 'wss://';

export type BackofficeUriError = 'scheme' | 'invalid';

export function stripWssScheme(value: string): string {
  const trimmed = value.trim();
  return trimmed.toLowerCase().startsWith(WSS_SCHEME) ? trimmed.slice(WSS_SCHEME.length) : trimmed;
}

export function validateWssHost(value: string): BackofficeUriError | null {
  const host = value.trim();
  if (!host) return 'invalid';
  if (host.includes('://')) return 'scheme';
  // 'wss:///ocpp' parses to hostname 'ocpp', so a leading slash has to be rejected up front.
  if (host.startsWith('/')) return 'invalid';
  try {
    const url = new URL(WSS_SCHEME + host);
    // Credentials would only be stored in plain text, the eConnector never reads them.
    if (url.username || url.password) return 'invalid';
    return url.hostname ? null : 'invalid';
  } catch {
    return 'invalid';
  }
}

export function buildWssUri(value: string): string {
  return WSS_SCHEME + value.trim();
}
